export enum WidgetNameEnum {
  'community-impact' = 'community-impact',
  'cumulative-impact' = 'cumulative-impact',
  'impact-overview' = 'impact-overview',
  'redeem-transaction' = 'redeem-transaction',
  'select-nonprofit' = 'select-nonprofit',
  'product-details-page' = 'product-details-page',
  'select-subscription-nonprofit' = 'select-subscription-nonprofit',
  'subscription-impact' = 'subscription-impact',
  'subscription-management' = 'subscription-management',
  'subscriber-select-nonprofit' = 'subscriber-select-nonprofit',
}

export type WidgetName = keyof typeof WidgetNameEnum
